import { Component, OnInit } from '@angular/core';
import { BaseComponent } from "app/components/base.component";
import { DocumentService, Document } from "app/services/document.service";
import { PaginationService } from 'app/services/pagination.service';
import { Router } from '@angular/router';
import * as _ from 'underscore';

@Component({
    selector: 'app-document',
    templateUrl: './document.component.html',
    styleUrls: ['./document.component.css']
})
export class DocumentComponent extends BaseComponent implements OnInit {
    documents: any;
    document: Document;
    error:any;
    file:any;

    private allItems: Document[];
    private allItemsOri: Document[];
    
    q: string = '';

    pager: any = {};

    pagedItems: any[];

    constructor(
        private documentService: DocumentService,
        private router: Router,
        private paginationService: PaginationService,
    ) {
        super();
    }

    ngOnInit() {
        this.documentService.getDocuments().subscribe(documents => {
            this.documents = documents.sort((a, b)=> {
                if(a.created_at == b.created_at)
				{
					return 0;
				}
				return a.created_at > b.created_at ? -1 : 1;
            });
            this.allItemsOri = _.clone(this.documents);
			this.allItems = _.clone(this.documents);
            this.setPage(1);
        });
        this.document = new Document();
    }

    //Upload function
    upload() {
        var uploader = document.getElementsByClassName('progress-bar')[0];
        var progress = document.getElementsByClassName('progress')[0];
        var closeBtn = document.getElementsByClassName('close-btn');
        var modalTitle = document.getElementsByClassName('modal-title')[0];
        var target = (<HTMLInputElement>document.getElementById('document'));
        var file_name_element = <HTMLDivElement>document.getElementById("file-used");
        var fileLenght = target.files.length;

        if(fileLenght !== 0) {
            var pdf = target.files[0].type.match('application/pdf');
        }

        if(fileLenght === 0) {
            this.error = 'No file selected';
        } else if(!pdf) {
            this.error = 'Please upload pdf file';
        } else {
            this.error = '';
            for (var i=0; i<target.files.length; i++){
                var selectedFile = target.files[i];
                var data = {
                    uploader,
                    closeBtn,
                    modalTitle,
                    selectedFile,
                    progress,
                    file_name_element
                }
                this.documentService.documentUpload(data);
            }
            target.value = '';
            
        }
    }

    
    onDocumentClick(document) {
        this.document = document;
        console.log(this.document);
    }

    onDelete(name, key) {
        if (confirm('Are you sure?')) {
            this.documentService.deleteDocument(name, key);
            this.router.navigate(['/media/document']);
        }
    }

    filechange(event: Event) {
        var input = <HTMLInputElement>event.target;
        var file_name_element = <HTMLDivElement>document.getElementById("file-used");
        var alert = <HTMLDivElement>document.getElementById("hidden");
        // var file = input.files[0];
        var file = []
        for(var i=0; i<input.files.length; i++){
            file.push(input.files[i].name);
        }
        // file_name_element.innerHTML = file.join(', ')
        this.file = input.files
        // console.log( this.file)
        this.error = '';
    }

    setPage(page: number) {
        // get pager object from service
        this.pager = this.paginationService.getPager(this.allItems.length, page);

        // get current page of items
        this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        setTimeout(() => {
            window.dispatchEvent(new Event('data-loaded'));
        }, 500);
    }

    filter_result() {
		if(this.q) {
			this.allItems = this.allItemsOri.filter(item => {
				var regex = new RegExp( this.escapeRegExp(this.q), 'gi' );
				
				var name = regex.test(item.name);

				return name;
			})
		}
		else
		{
			this.allItems = this.allItemsOri;
		}
		this.setPage(1);
	}

	escapeRegExp(str) {
		return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	}

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/media/document/document/document.component.ts